export default {
    namespaced: true,
    state: {
        commonKeyword: '', // 普通搜索的关键字
        isChangeCommonKeyFlag: false, // 记录普通关键词变化是否改变面板的标志
        isShowTipPanel: false, // 提示词面板的显隐
        isShowSearchResult: false, // 搜索结果面板的显隐
        isShowMessageDetail: false, // 控制附近信息面板的显隐

        aroundName: '', // 附近搜索的名字
        isShowRoundFlag: false, // 是否显示附近的搜索
        aroundKeyword: '', // 附近搜索的关键字
        isChangeAroundKeyFlag: '', // 记录附近关键词变化是否改变面板的标志
        refreshMapPointFlag: false, // 重新刷新地图点的标志

        isShowPathIcon: true,

        enterpriseTypeCount: [], // 查询到企业数据
    },
    actions: {
        commonKeywordEmit(state: any, data: any) {
            state.commit('commonKeywordUpdate', data);
        },
        isShowTipPanelEmit(state: any, data: any) {
            state.commit('isShowTipPanelUpdate', data);
        },
        isShowSearchResultEmit(state: any, data: any) {
            state.commit('isShowSearchResultUpdate', data);
        },
        isChangeCommonKeyFlagEmit(state: any, data: any) {
            state.commit('isChangeCommonKeyFlagUpdate', data);
        },
        isShowMessageDetailEmit(state: any, data: any) {
            state.commit('isShowMessageDetailUpdate', data);
        },
        aroundNameEmit(state: any, data: any) {
            state.commit('aroundNameUpdate', data);
        },
        isShowRoundFlagEmit(state: any, data: any) {
            state.commit('isShowRoundFlagUpdate', data);
        },
        aroundKeywordEmit(state: any, data: any) {
            state.commit('aroundKeywordUpdate', data);
        },
        isChangeAroundKeyFlagEmit(state: any, data: any) {
            state.commit('isChangeAroundKeyFlagUpdate', data);
        },
        refreshMapPointFlagEmit(state: any, data: any) {
            state.commit('refreshMapPointFlagUpdate', data);
        },
        isShowPathIconEmit(state: any, data: any) {
            state.commit('isShowPathIconUpdata', data);
        },
        EnterpriseTypeCountEmit(state: any, data: any) {
            state.commit('enterpriseTypeCount', data);
        },




    },
    mutations: {
        commonKeywordUpdate(state: any, data: any) {
            state.commonKeyword = data;
        },
        isShowTipPanelUpdate(state: any, data: any) {
            state.isShowTipPanel = data;
        },
        isShowSearchResultUpdate(state: any, data: any) {
            state.isShowSearchResult = data;
        },
        isChangeCommonKeyFlagUpdate(state: any, data: any) {
            state.isChangeCommonKeyFlag = data;
        },
        isShowMessageDetailUpdate(state: any, data: any) {
            state.isShowMessageDetail = data;
        },
        aroundNameUpdate(state: any, data: any) {
            state.aroundName = data;
        },
        isShowRoundFlagUpdate(state: any, data: any) {
            state.isShowRoundFlag = data;
        },
        aroundKeywordUpdate(state: any, data: any) {
            state.aroundKeyword = data;
        },
        isChangeAroundKeyFlagUpdate(state: any, data: any) {
            state.isChangeAroundKeyFlag = data;
        },
        refreshMapPointFlagUpdate(state: any, data: any) {
            state.refreshMapPointFlag = data;
        },
        isShowPathIconUpdata(state: any, data: any) {
            state.isShowPathIcon = data;
        },
        enterpriseTypeCountUpdata(state: any, data: any) {
            state.enterpriseTypeCount = data;
        },
    },
};
